import { getLabel } from "../../../../hooks/use-labels";

export const orderReasonStatuses = ["REJECTED", "DECLINED", "REFUNDED"];

const stepContent = {
  PENDING: {
    title: getLabel("orderPlacedStatusLabel"),
    subtitle: getLabel("sentYourOrderMessage"),
  },
  ACCEPTED: {
    title: getLabel("inProgressLabel"),
    subtitle: getLabel("confirmedOrderMessage"),
  },
  DISPATCHED: {
    title: getLabel("orderDispatched"),
    subtitle: getLabel("dispatchedOrderMessage"),
  },
  DELIVERED: {
    title: getLabel("orderDeliveredLabel"),
    subtitle: getLabel("deliveredOrderMessage"),
  },
  REFUNDED: {
    title: getLabel("orderRefunded"),
    subtitle: getLabel("orderRefundedMessage"),
  },
  REJECTED: {
    title: getLabel("orderRejectedLabel"),
    subtitle: getLabel("rejectedOrderMessage"),
  },
  CANCELLED: {
    title: getLabel("orderCancelledLabel"),
    subtitle: getLabel("supplierCancelledOrder"),
  },
  DECLINED: {
    title: getLabel("orderDeclinedLabel"),
    subtitle: getLabel("declinedOrderMessage"),
  },
};

export const decorateTimeline = (timeline) =>
  (timeline || []).map((step) => ({
    ...step,
    title: step.title || stepContent[step.step]?.title || step.step,
    subtitle: step.subtitle || stepContent[step.step]?.subtitle || null,
  }));

export const orderTrackState = (timeline) => {
  const steps = timeline || [];

  if (steps.some((step) => step.terminal && step.completed)) return "cancelled";

  if (steps.some((step) => step.step === "DELIVERED" && step.completed))
    return "delivered";

  return "";
};
